'use client'

// @ts-strict-ignore
import { SmartCaptcha } from '@yandex/smart-captcha'
import { useCallback, useState } from 'react'

import { sendYandexMetricaEvent } from '@/shared/integrations/yandex-metric/utils/send-metric-event'
import { YANDEX_CAPTCHA_KEY } from '@/shared/lib/const/env'

import { useServiceForm } from '../../hook/use-service-form'

import { FormStatus } from './form-status/form-status'
import { Form } from './form/form'
import { FormSubmit } from './submit/form-submit'

import cl from './service-form.module.scss'

export const ServiceForm = () => {
	const [captcha, setCaptcha] = useState<string>('')

	const {
		control,
		availableServiceCenters,
		userInfoIsLoading,
		onSubmit,
		onRetry,
		formState: { isError, isLoading, isSuccess },
		userType,
		setValue,
		showNewsletterCheckbox,
		isNewsletterAccepted,
		setIsNewsletterAccepted
	} = useServiceForm(captcha)
	const onChange = useCallback(
		(value: string) => {
			setCaptcha(value)
			setValue('recaptcha_response', value)
		},
		[setCaptcha] // eslint-disable-line react-hooks/exhaustive-deps
	)

	const onFormSubmit = async () => {
		try {
			await onSubmit()
			sendYandexMetricaEvent(`send_service_request`)
		} catch (error) {
			console.error('Ошибка при отправке формы:', error)
		}
	}
	return (
		<div className={cl.root}>
			<form
				className={cl.form}
				onSubmit={e => {
					e.preventDefault()
					onFormSubmit()
				}}>
				<Form
					formControl={control}
					userType={userType}
					availableServiceCenters={availableServiceCenters}
					userInfoIsLoading={userInfoIsLoading}
					isLoading={isLoading}
					showNewsletterCheckbox={showNewsletterCheckbox}
					isNewsletterAccepted={isNewsletterAccepted}
					onNewsletterChange={setIsNewsletterAccepted}
				/>

				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '2rem' }}>
					<SmartCaptcha sitekey={YANDEX_CAPTCHA_KEY} onSuccess={onChange} language={'ru'} />
				</div>

				<FormSubmit isLoading={isLoading} disabled={!captcha} />
			</form>
			<FormStatus status={isError || isSuccess ? (isSuccess ? 'success' : 'error') : null} onRetry={onRetry} />
		</div>
	)
}
